<template>
  <!-- 直播围观人数 -->
  <div class="live-top">
    <div class="live-people">
      <template v-for="(item,index) in viewerList.slice(0,3)">
          <img
            class="live-logo"
            :src="JSON.parse(item).avatarUrl"
            v-if="JSON.parse(item).avatarUrl"
            :key="index"
            v-load="'oAvatarSmall'"
          />
          <img class="live-logo" src="@/assets/img/empty.png" v-else  :key="index"/>
      </template>
      <div
        class="live-count"
        :class="viewerNum > 0 ?'':'live-count-none'"
      >{{this.getCount(viewerNum)}}</div>
    </div>
    <!-- <div class="live-info">
      <div class="live-info-content">
        <img
          src="https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3744215463,383557679&fm=26&gp=0.jpg"
        />
        <p>
          <span>美利达新品发布会</span>正在直播，诚邀您的加入
        </p>
      </div>
    </div> -->
    <!-- <van-action-sheet :value="show" @click-overlay="onClose" class="m-action-sheet">
      <template v-if="viewerList.length > 0">
        <div class="m-list">
          <div class="m-list-title">在线观众</div>
          <div class="m-list-content">
            <van-list
              class="m-list-wrap"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              offset="100"
              @load="loadList"
              ref="listCheck"
            >
              <div class="m-list-item" v-for="(item,index) in viewerList" :key="index">
                <img
                  :src="item.userInfo.HeadImgUrl"
                  class="mli-avatar"
                  v-if="item.userInfo && item.userInfo.HeadImgUrl"
                />
                <img src="@assets/img/empty.png" class="mli-avatar" v-else />
                <div class="mli-info">{{item.userInfo.Name}}</div>
                <div class="mli-brand">{{item.userInfo.RoleName}}</div>
              </div>
            </van-list>
          </div>
        </div>
      </template>
      <div class="m-list" v-else>
        <div class="empty">暂无数据</div>
      </div>
    </van-action-sheet> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import config from "../../../static/config.json";

export default {
  name: "navigation",
  data() {
    return {
      viewerList:[],
      viewerNum:null,
    }
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
      userInfo: "getUserInfo",
      roomId:"getRoomid"
    }),
    option() {
      return {
        exhibitionId: this.exhibitionId,
      };
    }
  },
  methods: {
    ...mapActions({
      getRoomTopUser:'company/getRoomTopUserNew',
      addRoomViewer:'company/addRoomViewer',
    }),
    async init(){
      // this.addViewer();
      let userlist = await this.getRoomTopUser(this.option);
      this.viewerNum = userlist.viewUser;
      console.log(userlist,'userlist');
      if(userlist.userInfos && userlist.userInfos.length){
        this.viewerList = userlist.userInfos;
      }
    },
    async addViewer(){ // 添加直播间的用户浏览
      let userInfo = {avatarUrl:this.userInfo.avatarUrl,name:this.userInfo.nickName || this.userInfo.name}
      let body = {
          roomId: this.roomId,
          userId: this.userInfo.userId,
          userInfo: JSON.stringify(userInfo),
      };
      await this.addRoomViewer(body);
    },
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
  }
};
</script>

<style scoped lang="scss">
.live-top {
  top: 1.05rem;
  padding: 0 0.2rem;
  position: absolute;
  z-index:101;
  min-height: 0.6rem;
  width: 100%;
  display: flex;
  align-items: center;
}
.live-info {
  width: 80%;
  height: 0.6rem;
  line-height: 0.6rem;
  background-image: url(../../assets/img/live/arrow-l.png),
    url(../../assets/img/live/arrow-r.png),
    linear-gradient(0deg, #ff4b1f 0%, #ff9068 100%), linear-gradient(#000, #000);
  background-repeat: no-repeat;
  background-size: 0.47rem 0.29rem, 0.49rem 0.33rem, auto, auto;
  background-position: 2% 30%, 98% 70%, 0% 0%, 0% 0%;
  border-radius: 0.3rem 0.3rem 0.3rem 0.3rem;
  &-content {
    width: 80%;
    padding: 0 0.5rem;
    height: 0.6rem;
    line-height: 0.6rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: flex;
    align-items: center;
    img {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 50%;
      display: inline-block;
      margin-right: 0.15rem;
      background-color: #fff;
    }
    p {
      color: #fff;
      width: 3.5rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-top: .05rem;
    }
  }
}
.live-people {
  min-width: 2rem;
  width: 20%;
  height: 0.46rem;
  display: flex;

}

.live-logo {
  width: 0.46rem;
  height: 0.46rem;
  border-radius: 50%;
  display: block;
  border: 1px solid #fff;
}

.live-logo:nth-child(1) {
  z-index: 103;
  position: relative;
}

.live-logo:nth-child(2) {
  z-index: 102;
  position: relative;
  margin-left: -0.2rem;
}

.live-logo:nth-child(3) {
  z-index: 99;
  position: relative;
  margin-left: -0.2rem;
}

.live-count {
  min-width: 0.96rem;
  height: 0.46rem;
  /*line-height: 0.46rem;*/

  color: #fff;
  font-size: 0.2rem;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 0.46rem;
  display: flex;
    align-items: center;
    justify-content: center;
  padding-left: 0.36rem;
  margin-left: -0.34rem;
  text-align: center;
  padding-right: 0.1rem;
}

.live-count-none {
  margin: 0;
  padding: 0;
}
.m-action-sheet {
  height: 6.5rem;
}
/* 组件 */
.m-list {
  padding: 0;
}

.m-list-title {
  line-height: 0.9rem;
  text-align: center;
  font-size: 0.26rem;
  font-weight: 600;
  border-bottom: 1px solid #f2f2f2;
}

.m-list-content {
  padding-left: 0.3rem;
  min-height: 0.3rem;
  font-size: 0.26rem;
}
.m-list-wrap {
  border-radius: 0.17rem 0.17rem 0 0;
}
.m-list-item {
  height: 1rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f2f2f2;
}

.mli-avatar {
  width: 0.56rem;
  height: 0.56rem;
  background-color: #fff;
  border-radius: 50%;
}

.mli-info {
  padding-left: 0.18rem;
  font-size: 0.26rem;
  color: #333;
  margin-right: 0.1rem;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mli-brand {
  font-size: 0.2rem;
  color: #666;
  width: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.my-half-title {
  font-size: 0.4rem;
}

.empty {
  line-height: 4rem;
  text-align: center;
  color: #ccc;
  font-size: 0.4rem;
}

.load {
  text-align: center;
  padding: 10px;
}

.page-section-spacing {
  margin-top: 60px;
}
.scroll-view_H {
  white-space: nowrap;
}
.scroll-view-item {
  height: 0.6rem;
}
.scroll-view-item_H {
  display: inline-block;
  width: 100%;
  height: 0.6rem;
}
.demo-text-1 {
  background: red;
}
.demo-text-2 {
  background: green;
}
.demo-text-3 {
  background: blue;
}
</style>
